<template>
  <div
    class="Fuell-Overlay"
    @click.self="closeModal"
    v-if="visible"
  >
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window Fuell-Modal--window--centered">
        <button
          class="Fuell-Modal--close-button"
          @click="closeModal"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt="close"
          />
        </button>
        <h3 class="Fuell-Modal--title">
          <span v-t="{ path: 'users_import_users' }"></span>
        </h3>

        <div
          class="Fuell-Modal--content"
          v-if="loading"
        >
          <spinner></spinner>
        </div>
        <div
          class="Fuell-Modal--content"
          v-else
        >
          <template v-if="success">
            <div class="Fuell-Text pb-4">
              {{ $t('users_import_invitations_sent') }}
            </div>
            <button
              class="Fuell-Button blue mx-auto"
              type="button"
              @click="handleClose"
            >
              <span class="Fuell-Button--label">
                {{ $t('ACTION_ACCEPT') }}
              </span>
            </button>
          </template>
          <template v-else-if="waiting_approval">
            <div class="Fuell-Text pb-4">
              {{ $t('users_import_invitations_waiting_approval') }}
              <a
                class="link"
                @click="openSupport"
              >
                {{ $t('users_import_invitations_waiting_approval_contact') }}
              </a>
            </div>
            <button
              class="Fuell-Button blue mx-auto"
              type="button"
              @click="handleClose"
            >
              <span class="Fuell-Button--label">
                {{ $t('ACTION_ACCEPT') }}
              </span>
            </button>
          </template>
          <template v-else-if="confirm">
            <div
              id="import-confirm"
              class="Fuell-Text"
            >
              {{ $t('users_import_confirm_intro') }}
            </div>
            <table
              aria-describedby="import-confirm"
              class="table table-sm mt-3 invalid-users-table"
              v-if="users.length > 0"
            >
              <thead>
                <tr>
                  <th scope="col">{{ $t('users_import_table_name') }}</th>
                  <th scope="col">{{ $t('users_import_table_email') }}</th>
                  <th scope="col">{{ $t('users_identifier') }}</th>
                  <th scope="col">{{ $t('users_expense_center') }}</th>
                  <th scope="col">{{ $t('users_import_table_role') }}</th>
                  <th
                    scope="col"
                    v-if="currentCompanyHasOptionalCards || currentCompanyHasCards"
                  >{{$t('users_import_table_card_emission')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="user in users"
                  :key="user.email"
                >
                  <td>{{ user.name }} {{ user.lastName }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.identifier }}</td>
                  <td>{{ user.expenseCenter }}</td>
                  <td>{{ $t(`user_role__${user.role}`) }}</td>
                  <td v-if="currentCompanyHasOptionalCards || currentCompanyHasCards">
                    {{ checkUserCardInfo(user) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="flex pt-4">
              <button
                class="Fuell-Button red ml-auto mr-4"
                @click="resetConfirm"
                type="button"
              >
                <span class="Fuell-Button--label">
                  {{ $t('ACTION_GO_BACK') }}
                </span>
              </button>
              <button
                class="Fuell-Button blue mr-auto"
                type="button"
                @click="handleConfirm"
              >
                <span class="Fuell-Button--label">
                  {{ $t('ACTION_CONTINUE') }}
                </span>
              </button>
              <confirm-modal
                v-if="showConfirmModalFlag"
                :open.sync="showConfirmModalFlag"
                :title="'users_import_users'"
                ignore-default-message
                :message="''"
                :dismissText="'ACTION_CANCEL'"
                :acceptText="'users_import_users'"
                @accept="handleConfirmAction"
              >
                <template
                  v-slot:additional
                  :extraInfo="stats"
                >

                  <i18n
                    tag="p"
                    class="Fuell-Text text-center"
                    path="users_import_confirm_modal_message"
                  >
                    <template v-slot:count>
                      <span class="font-weight-bold">{{stats.total}} {{$t('USERS_KEYWORD').toLowerCase()}}</span>
                    </template>
                    <template v-slot:regular>
                      {{stats.regular}}
                    </template>
                    <template v-slot:bookkeeper>
                      {{stats.bookkeeper}}
                    </template>

                  </i18n>
                </template>

              </confirm-modal>
            </div>
          </template>
          <template v-else>
            <template v-if="!errorMessage">
              <template v-if="!file">
                <i18n
                  class="Fuell-Text text-justify"
                  path="users_import_users_description"
                  tag="div"
                >
                  <template v-slot:downloadLink>
                    <a
                      href="/fuell_users_import_optional_cards.xlsx"
                      class="link"
                      v-if="currentCompanyHasOptionalCards"
                    >{{$t('users_import_users_download_template')}}</a>
                    <a
                      href="/fuell_users_import_no_cards.xlsx"
                      class="link"
                      v-else-if="currentCompanyHasNoCards"
                    >{{$t('users_import_users_download_template')}}</a>
                    <a
                      href="/fuell_users_import_cards.xlsx"
                      class="link"
                      v-else-if="currentCompanyHasCards"
                    >{{$t('users_import_users_download_template')}}</a>
                  </template>
                </i18n>
                <template v-if="currentCompanyHasOptionalCards">
                  <span
                    class="Fuell-Text my-1 text-danger"
                    v-t="{path: 'users_import_optional_card_warning'}"
                  ></span>
                </template>
                <upload-zone
                  @selected="handleSelectedFile"
                  :text="$t('users_import_select_file_text')"
                  :valid-mime-types="validMimeTypes"
                ></upload-zone>
              </template>
              <template v-else>
                <div class="Fuell-Text text-justify">
                  {{ $t('users_import_selected_file_intro') }}
                </div>
                <div class="file my-4">
                  {{ file.name }}
                </div>
                <div class="flex">
                  <button
                    class="Fuell-Button red ml-auto mr-4"
                    @click="resetFile"
                    type="button"
                  >
                    <span class="Fuell-Button--label">
                      {{ $t('users_import_button_wrong_file') }}
                    </span>
                  </button>
                  <button
                    class="Fuell-Button blue mr-auto"
                    type="button"
                    @click="handleUpload"
                  >
                    <span class="Fuell-Button--label">
                      {{ $t('ACTION_CONTINUE') }}
                    </span>
                  </button>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="Fuell-Text my-2">
                <span id="import-error">{{ $t(errorMessage) }} <a
                    href="#"
                    @click="openSupport"
                    class="text-primary"
                  > {{$t('intercom_message_variation_message')}} </a> </span>
              </div>
              <table
                class="table table-sm mt-3 invalid-users-table"
                aria-describedby="import-error"
                v-if="usersWithError.length > 0"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ $t('users_import_table_name') }}</th>
                    <th scope="col">{{ $t('users_import_table_email') }}</th>
                    <th scope="col">{{ $t('users_import_table_issue') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(user, key) in usersWithError"
                    :key="key"
                  >
                    <td>{{ user.name }} {{ user.lastName }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ getViolationsString(user.violations) }}</td>
                  </tr>
                </tbody>
              </table>
              <button
                type="button"
                class="Fuell-Button red"
                @click="resetError"
              >
                <span class="Fuell-Button--label">
                  {{ $t('ACTION_GO_BACK') }}
                </span>
              </button>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import UploadZone from '@/components/Commons/UploadZone'
import Spinner from '@/components/Commons/Spinner'
import usersApi from '../../_api'

import { MIMETYPES } from '@/utils/constants'
import { segmentTrack } from '@/analytics/segment'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

const ROLES = {
  ROLE_REGULAR: 'ROLE_REGULAR',
  ROLE_BOOKKEEPER: 'ROLE_BOOKKEEPER'
}

export default {
  mixins: [_modalHandlerMixin],
  components: {
    UploadZone,
    ConfirmModal,
    Spinner
  },
  data () {
    return {
      validMimeTypes: [MIMETYPES.EXCEL, MIMETYPES.CSV],
      errorMessage: null,
      usersWithError: [],
      users: [],
      file: null,
      confirm: false,
      loading: false,
      stats: {},
      resourceID: null,
      success: false,
      waiting_approval: false,
      pending: false,
      showConfirmModalFlag: false
    }
  },
  computed: {
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany']
    },
    currentCompanyHasOptionalCards () {
      return this.currentCompany && this.currentCompany.officeCardsType ? this.currentCompany.officeCardsType === 'OFFICE_CARDS_OPTIONAL' : false
    },
    currentCompanyHasNoCards () {
      return this.currentCompany?.officeCardsType === 'OFFICE_CARDS_WITHOUT'
    },
    currentCompanyHasCards () {
      return this.currentCompany?.officeCardsType === 'OFFICE_CARDS_ALWAYS'
    }
  },
  methods: {
    handleSelectedFile (file) {
      this.file = file
    },
    async openSupport () {
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(this.$t('intercom_import_users_message'))
      }
    },
    resetFile () {
      this.file = null
    },
    resetError () {
      this.errorMessage = null
      this.usersWithError = []
    },
    resetUsers () {
      this.users = []
    },
    resetConfirm () {
      this.confirm = null
      this.resourceID = null
      this.resetFile()
      this.resetError()
      this.resetUsers()
    },
    handleClose () {
      this.closeModal()
    },
    handleConfirm () {
      this.showConfirmModalFlag = true
    },
    handleConfirmAction () {
      this.loading = true
      usersApi
        .confirmMassiveImport(this.resourceID)
        .then(async (res) => {
          if (res.data.status === 'CONFIRMED') {
            this.waiting_approval = true
          }
          if (res.data.status === 'COMPLETED') {
            await this.$store.dispatch('UsersStore/fetchUsers')
            this.success = true
          }
          segmentTrack('User massive import confirm success', {
            total_users_count: res.data.totalEntriesCount,
            total_valid_users_count: res.data.validEntriesCount
          })
        })
        .catch((err) => {
          console.error(err)
          segmentTrack('User massive import confirm error')
        })

        .finally(() => {
          this.loading = false
        })
    },
    checkUserCardInfo (user) {
      if (!user) return ''
      if (user.role === 'ROLE_BOOKKEEPER') {
        return this.$i18n.t('user_card_usage_not_applicable')
      }

      return user.userCardsType === 'USER_CARDS_ALWAYS' ? this.$i18n.t(`user_card_usage_type__${user.typeOfCardWhenRegisteredOnIssuer}`) : this.$i18n.t('customer_user_without_cards')
    },
    handleUpload () {
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.file)

      usersApi
        .createMassiveImport(formData)
        .then((res) => res.data)
        .then((data) => {
          if (data.totalEntriesCount > 0 && data.invalidEntriesCount === 0) {
            this.confirm = true
            this.resourceID = data.id
            this.users = data.data.filter((i) => i.valid)
            this.stats = {
              total: data.validEntriesCount,
              regular: data.data.filter((i) => i.role === ROLES.ROLE_REGULAR).length,
              bookkeeper: data.data.filter((i) => i.role === ROLES.ROLE_BOOKKEEPER).length
            }
          } else {
            this.errorMessage = 'users_import_invalid_users'
            this.usersWithError = data.data.filter((i) => !i.valid)
          }
        })
        .catch(() => {
          this.errorMessage = 'users_import_invalid_file'
        })
        .finally(() => {
          this.resetFile()
          this.loading = false
        })
    },
    getViolationsString (violations) {
      return violations
        .map((violation) => this.$t(`users_import_violation_${violation}`))
        .join(',')
    },
    getConfirmModalMessage () {
      return this.$t('users_import_confirm_modal_message', {
        count: this.stats.total,
        regular: this.stats.regular,
        bookkeeper: this.stats.bookkeeper
      })
    }
  }
}
</script>

<style>
.link {
  color: var(--blue-action-1-active) !important;
  cursor: pointer;
}
.invalid-users-table {
  font-size: 13px;
}
</style>
